import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class TagSearchItem extends PureComponent {
  handleChange = e => {
    const { tag, onClick } = this.props;
    onClick(tag);
  };

  getClassName = () => {
    const { tag } = this.props;
    return `Tag-big ${tag.displayClass}`;
  };

  render() {
    const { tag } = this.props;
    return (
      <button className={this.getClassName()} onClick={this.handleChange}>
        <span>{tag.name}</span>
      </button>
    );
  }
}

TagSearchItem.propTypes = {
  tag: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default TagSearchItem;



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/TagSearchBar/TagSearchItem.js